export default "__VITE_ASSET__D4duug3p__"